export const PAGE_VIEWED = 'Viewed Tag Page';
export const PAGINATION_CLICK = 'Tag page - Pagination - Click';
export const INTRO_VIDEO_LINK_CLICK = 'Tag page - Intro Video Link - Click';
export const REGISTRATION_BUTTON_CLICK = 'Tag page - Registration Button - Click';
export const RELATED_LINK_CLICK = 'Tag page - Related Links - Click';
